import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'topo-color-display',
    templateUrl: './color-display.component.html',
    styleUrls: ['./color-display.component.scss'],
    standalone: false
})
export class ColorDisplayComponent implements OnInit {
  @Input() htmlColorCode = '#DDDDDD';
  @Input() size = 10;
  @Input() radius = 10;
  @Input() showHtmlColorCode = true;

  constructor() {}

  ngOnInit(): void {}
}
